import { render, staticRenderFns } from "./WorkflowFilter.vue?vue&type=template&id=61b32656&scoped=true"
import script from "./WorkflowFilter.vue?vue&type=script&lang=js"
export * from "./WorkflowFilter.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFilter.vue?vue&type=style&index=0&id=61b32656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b32656",
  null
  
)

export default component.exports